const messages = {
  title: "Consensi marketing",
  required: "Obbligatorio",
  answered: "✓ Risposto",
  read: "Letto",
  notRead: "Non letto",
  alreadyAnswered: "Già risposto",
  requiredQuestionsMustBeAccepted:
    "È necessario accettare {count} domanda/e obbligatoria/e",
  pleaseAnswerQuestions: "Rispondere alle seguenti domande:",
  iAccept: "Accetto",
  scrollToUnlock: "Scorri fino in fondo per sbloccare",
  fieldRequired: "Questo campo è obbligatorio",
  scrollToContinue: "↓ Scorri fino in fondo per continuare",
  saving: "Salvataggio in corso...",
  saveConsents: "Salva consensi",
  allRequiredAccepted: "✓ Tutte le domande obbligatorie accettate",
  requiredConsentsCompleted:
    "{completed}/{total} consensi obbligatori completati",
  selectConsentToView:
    "Seleziona un consenso dall'elenco per visualizzarne il contenuto",
  readAllContentFirst: "Leggere prima tutto il contenuto: {names}",
  acceptAllRequiredIn:
    "Accettare tutte le domande obbligatorie in: {names}",
  acceptAllBeforeSaving:
    "Accettare tutte le domande obbligatorie prima di salvare.",
  failedToSave: "Impossibile salvare i consensi. Riprovare.",
  errorSaving:
    "Si è verificato un errore durante il salvataggio dei consensi. Riprovare.",
  failedToLoad: "Impossibile caricare i consensi. Aggiornare la pagina.",
  viewPdf: "Visualizza PDF",
  requiredConsentTitle: "Consenso obbligatorio",
  acceptAndContinue: "Accetta e continua",
};

export default {
  messages,
};
